module.exports = __webpack_public_path__ + "static/screen-pushit-2-6ce80e6c45553c7d11c8a9d5a4125626.jpg";